<sim-base-chip-input
	[formState]="vogSetFc"
	[label]="label"
	[placeholder]="placeholder"
	[isMultiSelect]="canSelectMultipleVogSets"
	[autoCompleteValues]="autoCompleteData"
	[debounceConfig]="{time: 200}"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
